import React from 'react';

import { EuiFlexGroup, EuiFlexItem } from '../../../../src/components';

export default () => (
  <EuiFlexGroup justifyContent="spaceAround">
    <EuiFlexItem grow={false}>I&rsquo;m a single centered item!</EuiFlexItem>
  </EuiFlexGroup>
);
